import React from 'react';
import PropTypes from 'prop-types';
import TableWithSorter from '../../../../components/Common/TableWithSorter';

const LearnerSocialMediaTable = ({
  loading,
  data,
  columns,
  totalCount,
  pageSizeOptions,
  onPaginationChange,
}) => (
  <>
    <TableWithSorter
      tableLayout="auto"
      scroll={{ x: 1000 }}
      expandable={{ defaultExpandAllRows: true }}
      loading={loading}
      dataSource={data}
      columns={columns}
      pagination={{
        total: totalCount,
        defaultPageSize: pageSizeOptions[0],
        showSizeChanger: true,
        pageSizeOptions,
      }}
      onChange={onPaginationChange}
    />
  </>
);

LearnerSocialMediaTable.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  columns: PropTypes.array.isRequired,
  totalCount: PropTypes.number.isRequired,
  pageSizeOptions: PropTypes.array.isRequired,
  onPaginationChange: PropTypes.func.isRequired,
};

LearnerSocialMediaTable.defaultProps = {
  totalCount: 0,
  data: [],
};

export default LearnerSocialMediaTable;
